
import { Component, Vue, Prop } from "vue-property-decorator";
import QuillEditor from "./QuillEditor.vue";
import { updateContent } from "../../services/ContentService";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { getValidationState, validateContext } from "../../utils/Validation";
import User from "../../models/User";
import {
  Content,
  Product,
  Contentable,
  Company,
} from "@authentic-labs/vue-component-library";

@Component({
  components: {
    QuillEditor,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class ContentEdit extends Vue {
  @Prop()
  index!: number;
  @Prop()
  company!: Company;
  @Prop()
  product!: Product;

  // @Prop()
  // contentableType!: string;

  get user(): User {
    return this.$store.getters.authUser;
  }
  get content(): Content {
    return this.contentable.unpublishedContent[this.index];
  }
  get contentable(): Contentable {
    if (!this._contentable) {
      throw new Error("Content object is not set");
    }
    return this._contentable;
  }
  get listClass() {
    if (this.product) {
      return "product-edit";
    }
    return "company-edit";
  }

  private _contentable?: Contentable;
  private contentableType?: string;

  validate(context: validateContext) {
    return getValidationState(context);
  }

  created() {
    this._contentable = this.company ?? this.product;
    this.company ? this.contentableType = "company" : this.contentableType = "product"
  }

  async onSave() {
    const updatedContent: Content[] = [];
    this.content.content = this.removeEmptyParagraph(this.content.content);
    updatedContent.push(this.content);
    try {
      await updateContent(this.contentable, updatedContent);
      this.company
        ? this.$store.commit("setCompany", this.contentable)
        : this.$store.commit("setProduct", this.contentable);
      this.$root.$emit("alertSuccess", "Content updated!");
      this.$root.$emit("show-content-list");
      this.company
        ? this.$root.$emit("content-saved", "company")
        : this.$root.$emit("content-saved");
    } catch (error) {
      console.error("Error: Unable to update content. Please try again later.");
    }
  }

  async onCancel() {
    this.$root.$emit("show-content-list");
  }

  removeEmptyParagraph(content: string) {
    const tmpContent = content.replace(/<p><br><\/p>/g, "");
    //need to keep an empty paragraph after video insertion to allow the user to remove the video.
    //The video is always embedded in an iFrame which is being keyed on here.
    //The other solution (which would be a preferable one) is to let Quill be Quill, have the user manage the empty
    //paragraphs and stop auto removing them.
    content = tmpContent;
    const vidCheck = tmpContent.split("</iframe>");
    if (vidCheck) {
      content = vidCheck.join("</iframe><p><br></p>");
    }
    return content;
  }
}
